import queryString from 'query-string'

const CREATE_NEXT_LEVEL = 'dofe-bo/nextLevel/CREATE_NEXT_LEVEL'
const CREATE_NEXT_LEVEL_SUCCESS = 'dofe-bo/nextLevel/CREATE_NEXT_LEVEL_SUCCESS'
const CREATE_NEXT_LEVEL_FAIL = 'dofe-bo/nextLevel/CREATE_NEXT_LEVEL_FAIL'

const GET_PAYMENT_OPTIONS = 'dofe-bo/nextLevel/GET_PAYMENT_OPTIONS'
const GET_PAYMENT_OPTIONS_SUCCESS =
  'dofe-bo/nextLevel/GET_PAYMENT_OPTIONS_SUCCESS'
const GET_PAYMENT_OPTIONS_FAIL = 'dofe-bo/nextLevel/GET_PAYMENT_OPTIONS_FAIL'

const PAYMENT_INITIALIZATION = 'dofe-bo/nextLevel/PAYMENT_INITIALIZATION'
const PAYMENT_INITIALIZATION_SUCCESS =
  'dofe-bo/nextLevel/PAYMENT_INITIALIZATION_SUCCESS'
const PAYMENT_INITIALIZATION_FAIL =
  'dofe-bo/nextLevel/PAYMENT_INITIALIZATION_FAIL'

const GET_REG_INFO = 'dofe-bo/nextLevel/GET_REG_INFO'
const GET_REG_INFO_SUCCESS = 'dofe-bo/nextLevel/GET_REG_INFO_SUCCESS'
const GET_REG_INFO_FAIL = 'dofe-bo/nextLevel/GET_REG_INFO_FAIL'

const SEND_REG_CODE = 'dofe-bo/nextLevel/SEND_REG_CODE'
const SEND_REG_CODE_SUCCESS = 'dofe-bo/nextLevel/SEND_REG_CODE_SUCCESS'
const SEND_REG_CODE_FAIL = 'dofe-bo/nextLevel/SEND_REG_CODE_FAIL'

const initialState = {
  loading: false,
  loaded: false,
  loadingOptions: false,
  loadedOptions: false,
  paymentOptions: []
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_NEXT_LEVEL:
      return {
        ...state,
        loading: true
      }
    case CREATE_NEXT_LEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CREATE_NEXT_LEVEL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_PAYMENT_OPTIONS:
      return {
        ...state,
        loadingOptions: true
      }
    case GET_PAYMENT_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingOptions: false,
        loadedOptions: true,
        paymentOptions: action.result
      }
    case GET_PAYMENT_OPTIONS_FAIL:
      return {
        ...state,
        loadingOptions: false,
        loadedOptions: false,
        error: action.error
      }
    case GET_REG_INFO:
      return {
        ...state,
        loadingInfo: true
      }
    case GET_REG_INFO_SUCCESS:
      return {
        ...state,
        loadingInfo: false,
        loadedInfo: true,
        awardInfo: JSON.parse(action.result)
      }
    case GET_REG_INFO_FAIL:
      return {
        ...state,
        loadingInfo: false,
        loadedInfo: false,
        error: action.error
      }
    default:
      return state
  }
}

export function createParticipant(code, data) {
  return {
    types: [
      CREATE_NEXT_LEVEL,
      CREATE_NEXT_LEVEL_SUCCESS,
      CREATE_NEXT_LEVEL_FAIL
    ],
    promise: client =>
      client.post(
        `api/participant-registrations/completion/using-authorization-code?authorizationCode=${code}`,
        {
          data,
          removeToken: true
        }
      )
  }
}

export function sendRegistrationCode(email) {
  return {
    types: [SEND_REG_CODE, SEND_REG_CODE_SUCCESS, SEND_REG_CODE_FAIL],
    promise: client =>
      client.post('api/registration/send-registration-code', {
        data: {
          email
        }
      })
  }
}

export function getPaymentOptions({
  birthDate,
  organizationId,
  awardLevel,
  isDirectLevelRegistration = false,
  previousAwardLevel = undefined
}) {
  return {
    types: [
      GET_PAYMENT_OPTIONS,
      GET_PAYMENT_OPTIONS_SUCCESS,
      GET_PAYMENT_OPTIONS_FAIL
    ],
    promise: client =>
      client.get(
        'api/participant-registrations/payment-options?' +
          queryString.stringify({
            birthDate,
            organizationId,
            awardLevel,
            isDirectLevelRegistration,
            previousAwardLevel
          }),
        {
          removeToken: true
        }
      )
  }
}

export function getRegistrationInfo(code) {

  return {
    types: [GET_REG_INFO, GET_REG_INFO_SUCCESS, GET_REG_INFO_FAIL],
    promise: client =>
      client.get(
        `api/participant-registrations/using-authorization-code?authorizationCode=${code}`,
        {
          removeToken: true,
          textResponse: true
        }
      )
  }
}

export function paymentInitialization(data) {
  return {
    types: [
      PAYMENT_INITIALIZATION,
      PAYMENT_INITIALIZATION_SUCCESS,
      PAYMENT_INITIALIZATION_FAIL
    ],
    promise: client =>
      client.post(
        'api/participant-registrations/online-payment-initialization',
        {
          removeToken: true,
          data
        }
      )
  }
}
